// Generated by scripts/build-ui-icons.mjs.
export { ToggleLeft as default } from "../ui/glyphs-7";
